module.exports = __webpack_public_path__ + "img/KSC01808.f9b56c3f.jpg";